import logo1 from '../../assets/Images/RPLogo1.png';

const HorizontalDivider = () => {
  return(
    <div className={'w-full my-2 flex items-center justify-center'}>
      <div className={'flex-grow h-[1px] bg-gradient-to-r from-primary-800 via-primary-800 to-transparent'} />
      <img src={logo1} className={'w-[40px]'} alt={'Logo'} />
      <div className={'flex-grow h-[1px] bg-gradient-to-l from-primary-800 via-primary-800 to-transparent'} />
    </div>
  );
};

export default HorizontalDivider;
